module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "tp1"
  }, [_vm._v("THE VERDICT")]), _vm._v(" "), _c('p', {
    staticClass: "tp2"
  }, [_vm._v("ON EACH MAN DEAD")]), _vm._v(" "), _c('p', {
    staticClass: "tp2"
  }, [_vm._v("DAVID")]), _vm._v(" "), _c('p', {
    staticClass: "tp3"
  }, [_vm._v("WHELLAMS")]), _vm._v(" "), _c('p', {
    staticClass: "tp4"
  }, [_vm._v("A PETER CAMMON MYSTERY")]), _vm._v(" "), _c('p', {
    staticClass: "tp4"
  }, [_vm._v("ECW Press")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/dude.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e6c507c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/verdictoneachmandead.vue
// module id = 60
// module chunks = 0